'use strict';

angular.module('far.admin')
    .controller('PostController', function (Post, form, $rootScope, Discipline, autocomplete, softdeleteable, fileUploadFilters, userQualificationGroups, $http) {
        (function init() {
            softdeleteable.setModel(Post);
        })();

        var errorMessages = [];


        var vm = {
            formPost: form('form'),
            form: {},
            progress: false,
            constructor: function (post) {
                vm.progress = !!post;
                vm.form = Post.get(post, function() {
                    vm.progress = false;

                    var disciplineWatch = $rootScope.$watch(function() {
                        return Discipline.list.length;
                    }, function(newVal) {
                        if (newVal > 0) {
                            Discipline.list.forEach(function(discipline_item) {
                                if ( vm.event ) {
                                    discipline_item.disabled = true;
                                }

                                if ( angular.isArray( vm.form.disciplines ) ) {
                                    vm.form.disciplines.forEach(function(selectedDiscipline) {
                                        if (discipline_item.id == selectedDiscipline.id) {
                                            discipline_item.selected = true;
                                        }
                                    });
                                }
                            });

                            disciplineWatch();
                        }
                    });

                    var qualificationWatch = $rootScope.$watch(function() {
                        return userQualificationGroups.list.length;
                    }, function(newVal) {
                        if (newVal > 0) {
                            userQualificationGroups.list.forEach(function(qualification_item) {
                                if ( angular.isArray( vm.form.post_user_qualification_groups ) ) {
                                    vm.form.post_user_qualification_groups.forEach(function(selectedQualification) {
                                        if (qualification_item.id === selectedQualification.id) {
                                            qualification_item.selected = true;
                                        }
                                    });
                                }
                            });

                            qualificationWatch();
                        }
                    });

                    var mountainAreaWatch = $rootScope.$watch(function() {
                        return mountainArea.length;
                    }, function(newVal) {
                        if (newVal > 0) {
                            mountainArea.forEach(function(mountainArea_item) {
                                if ( vm.event ) {
                                    mountainArea_item.disabled = true;
                                }

                                if ( angular.isArray( vm.form.mountain_areas ) ) {
                                    vm.form.mountain_areas.forEach(function(selectedMountainArea) {
                                        if (mountainArea_item.id == selectedMountainArea.id) {
                                            mountainArea_item.selected = true;
                                        }
                                    });
                                }
                            });

                            mountainAreaWatch();
                        }
                    });
                });
            },
            submit: function() {
                vm.form.save()
                    .then(function (response) {
                        vm.progress = true;
                        window.location.href = '/admin/blog/post/' + response.data.id;
                    }, function errorCallback(response) {
                        response = http.authenticationListener(response);
                        vm.errors = [];

                        if (angular.isDefined(response.data.errors) ) {
                            for ( var key in response.data.errors ) {
                                vm.errors.push(response.data.errors[key]);
                            }
                        } else {
                            showModalMessage('Ошибка на сервере. Попробуйте позже.');
                        }

                        vm.submitted = false;
                        vm.progress = false;
                    })
            },
            getRubricList: function() {
                var list = [];

                $http.get(Routing.generate('api_get_rubric_list'))
                    .then(function(response) {
                        response.data.forEach(function(item) {
                            item.selected = false;
                            list.push(item);
                        });
                    })
                    .catch(function(response) {
                        $log.error(response);
                    });

                return list;
            },
            getMountainAreaList: function() {
                var list = [];

                $http.get(Routing.generate('api_entities_get_mountain_area_list'))
                    .then(function(response) {
                        response.data.forEach(function(item) {
                            item.selected = false;
                            list.push(item);
                        });
                    })
                    .catch(function(response) {
                        $log.error(response);
                    });

                return list;
            }
        };

        var rubricList = vm.getRubricList();
        var mountainArea = vm.getMountainAreaList();

        vm.formPost
            .addField('name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Название',
                    class: 'form__item'
                }
            })
            .addField('header', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Заголовок',
                    class: 'form__item'
                }
            })
            .addField('title', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Title',
                    class: 'form__item'
                }
            })
            .addField('description', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Description',
                    class: 'form__item'
                }
            })
            /*.addField('rubric', 'uiSelect', {
                validators: {
                    required: true
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select margin_r_40'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Рубрика',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Rubric", "rubric")',
                        refreshDelay: 400
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function (item) {
                        vm.form.rubric = item;
                    }
                }
            }, autocomplete.get('rubric'))*/
            .addField('rubric', 'selectObject', {
                validators: {
                    required: true
                },
                options: {
                    defaultOption: 'Рубрика',
                    class: 'form__item form__item_select margin_r_40'
                },
                ngOptions: 'item as item.name for item in field.items track by item.id'
            }, rubricList)
            .addField('anons', 'textarea', {
                validators: {
                    required: false
                },
                options: {
                    redactor: {
                        minHeight: 100
                    },
                    placeholder: 'Небольшой анонс',
                    maxlength: 140,
                    class: 'form__item'
                }
            })
            .addField('content', 'textarea', {
                validators: {
                    required: false
                },
                options: {
                    redactor: {
                        minHeight: 300
                    },
                    placeholder: 'Основной текст',
                    rows: 20
                },
                redactor: {
                    minHeight: 300
                }
            })
            .addField('to_homepage', 'checkbox', {
                validators: {
                    required: false
                },
                label: 'На главную'
            })
            .addField('disciplines', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, Discipline.list)
            .addField('post_user_qualification_groups', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, userQualificationGroups.list)
            .addField('mountain_areas', 'checkboxCollection', {
                checkbox: {
                    label: 'name',
                    model: 'selected'
                }
            }, mountainArea)
            .addField('image', 'imageUpload', {
                validators: {
                    required: false
                },
                uploader: {
                    url: Routing.generate('api_upload_post_avatar'),
                    autoUpload: true,
                    removeAfterUpload: true,
                    filters: [
                        fileUploadFilters.fileSize()
                    ],
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    }
                }
            })
            .addField('slides_files', 'imageUpload', {
                validators: {
                    required: true
                },
                fieldData: {
                    multipleUpload: 'true'
                },
                label: 'Загрузить изображение',
                uploader: {
                    url: Routing.generate('api_upload_post_image'),
                    filters: [
                        fileUploadFilters.fileSize()
                    ],
                    autoUpload: true,
                    removeAfterUpload: true,
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';

                        if (errorMessages.indexOf(message) == -1) {
                            errorMessages.push(message);
                        }
                    },
                    onErrorItem: function () {
                        var message = 'Невозможно загрузить файл на сервер';

                        if (errorMessages.indexOf(message) == -1) {
                            errorMessages.push(message);
                        }
                    },
                    onCompleteAll: function () {
                        if (errorMessages.length > 0) {
                            showModalMessage(errorMessages.slice(0), 'Некоторые файлы не были загружены, т.к.:');
                            errorMessages = [];
                        }
                    }
                }
            })
            .addField('disable_comments', 'checkbox', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Отключить комментарии'
                },
                label: 'Отключить комментарии'
            })
        ;

        vm.formPost.$fields.image.uploader.onSuccessItem = function (item, response) {
            vm.form.image = response;
        };

        vm.formPost.$fields.slides_files.uploader.onSuccessItem = function (item, response) {
            vm.form.slides_files.push(response);
        };

        return vm;
    });
